import React, { useState, useEffect } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { keyframes } from "@emotion/react";
import { styled } from "@mui/material/styles";
import { Badge, Tooltip, tooltipClasses } from "@mui/material";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
// アニメーションの定義
const shakeAnimation = keyframes`
  0%, 20%, 40%,100% { transform: rotate(0deg); }
  5%,25% { transform: rotate(-15deg); }
  10%,30% { transform: rotate(15deg); }
  15%,35% { transform: rotate(-10deg); }
`;

// アイコンを包むコンテナ
const IconContainer = styled("div")`
  display: inline-block;
  transform-origin: top center;
  cursor: pointer;
  animation: ${shakeAnimation} 3s ease-in-out infinite;
`;

// スタイル付きアイコン
const StyledNotificationsIcon = styled(NotificationsIcon)`
  color: #ffd000;
  font-size: 2.5rem;
`;
// カスタムスタイルの Tooltip
const RedTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(255, 0, 0, 0.7)",
    color: "white",
    fontSize: "0.75rem",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgba(255, 0, 0, 0.7)",
  },
});
const NotificationBell = (props) => {
  const { count } = props;
  const [showTooltip, setShowTooltip] = useState(true);
  const dispatch = useDispatch();
  //   useEffect(() => {
  //     const timer = setTimeout(() => {
  //       setShowTooltip(false);
  //     }, 2000); // 2秒後にツールチップを非表示にする
  //     return () => clearTimeout(timer); // クリーンアップ
  //   }, []);

  return (
    <RedTooltip
      title="お知らせがあります"
      open={showTooltip}
      placement="bottom"
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -12], // ツールチップを上に8px移動
            },
          },
        ],
      }}
    >
      <Badge badgeContent={count} color="error">
        <IconContainer
          onClick={() => {
            dispatch(push(`/notice/list`));
          }}
        >
          <StyledNotificationsIcon />
        </IconContainer>
      </Badge>
    </RedTooltip>
  );
};

export default NotificationBell;
